// helper mixin for immutable CRUD operations on a collection
const ImmutableCollectionMixin = {
    methods: {
        $_immutableCollection_insert(collection, itemToInsert) {
            return [...collection, itemToInsert];
        },
        $_immutableCollection_update(collection, itemToUpdate) {
            return collection.map(item => {
                if (item._id === itemToUpdate._id) {
                    return itemToUpdate;
                }

                return item;
            });
        },
        $_immutableCollection_deleteById(collection, itemIdToDelete) {
            return collection.filter(item => {
                return item._id !== itemIdToDelete;
            })
        }
    }
};
export default ImmutableCollectionMixin;
